import React from "react";
import "./WhyIndiaSection.css";
import { FaChartLine, FaUsers, FaTrophy } from "react-icons/fa";

const WhyIndiaSection = () => {
  const stats = [
    {
      icon: <FaChartLine />,
      value: "$200B",
      label: "E-commerce Growth",
      subtext: "Projected by 2027",
      bg: "#EEF3FF"
    },
    {
      icon: <FaUsers />,
      value: "700M+",
      label: "Internet Users",
      subtext: "Expanding middle class",
      bg: "#E6FAF0"
    },
    {
      icon: <FaTrophy />,
      value: "85%",
      label: "Success Rate",
      subtext: "With strategic entry",
      bg: "#FFF8E6"
    },
  ];

  return (
    <section className="why-india-section">
      <h2>Why India? The Numbers Speak</h2>
      <p className="subtitle">The opportunity is massive and growing every day</p>

      <div className="stat-cards">
        {stats.map((stat, index) => (
          <div className="stat-card" key={index} style={{ backgroundColor: stat.bg }}>
            <div className="stat-icon">{stat.icon}</div>
            <h3>{stat.value}</h3>
            <p className="label">{stat.label}</p>
            <p className="subtext">{stat.subtext}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyIndiaSection;
